(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vexalune-immersive"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('vexalune-immersive')) {
    class VexaluneImmersive extends HTMLElement {
      connectedCallback() {
        this.reel = this.querySelector('.vx-reel');
        this.scenes = [...this.querySelectorAll('[data-vx-scene]')];
        this.dots = [...this.querySelectorAll('[data-vx-target]')];
        this.raf = 0;
        this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        this.dots.forEach((dot) => {
          dot.addEventListener('click', () => {
            const scene = this.scenes[Number(dot.dataset.vxTarget)];
            scene?.scrollIntoView({ behavior: this.reduced ? 'auto' : 'smooth', block: 'start' });
          });
        });

        this.reel.addEventListener('scroll', () => this.requestUpdate(), { passive: true });
        this.addEventListener('pointermove', (event) => this.setTilt(event), { passive: true });
        this.addEventListener('pointerleave', () => this.resetTilt(), { passive: true });
        this.requestUpdate();
      }

      requestUpdate() {
        if (this.raf) return;
        this.raf = requestAnimationFrame(() => {
          this.raf = 0;
          const height = this.reel.clientHeight || 1;
          const position = this.reel.scrollTop / height;
          const active = Math.max(0, Math.min(this.scenes.length - 1, Math.round(position)));

          this.scenes.forEach((scene, index) => {
            const distance = Math.abs(position - index);
            scene.style.setProperty('--vx-progress', Math.max(0, Math.min(1, 1 - distance)).toFixed(3));
          });

          this.dots.forEach((dot, index) => {
            if (index === active) dot.setAttribute('aria-current', 'true');
            else dot.removeAttribute('aria-current');
          });
        });
      }

      setTilt(event) {
        if (this.reduced || matchMedia('(pointer: coarse)').matches) return;
        const rect = this.getBoundingClientRect();
        const x = ((event.clientX - rect.left) / rect.width - .5) * 10;
        const y = ((event.clientY - rect.top) / rect.height - .5) * 10;
        this.style.setProperty('--vx-tilt-x', x.toFixed(2));
        this.style.setProperty('--vx-tilt-y', y.toFixed(2));
      }

      resetTilt() {
        this.style.setProperty('--vx-tilt-x', '0');
        this.style.setProperty('--vx-tilt-y', '0');
      }
    }

    customElements.define('vexalune-immersive', VexaluneImmersive);
  }

  } catch(e) { console.error(e); }
})();
})();
